import { gql } from "@apollo/client";

export const CreateInstalledBaseNodeAttributeOptionValue = gql`
    mutation CreateInstalledBaseNodeAttributeOptionValue ($id: ID!, $input: PropertyOptionValueCreateAttributesInput!){
        createInstalledBaseNodePropertyOptionValue (propertyId: $id, input: $input) {
            id
            label
            value
            parentOptionValues {
                id
                value
                label
            }
        }
    }
`;
